export default "__VITE_ASSET__e5c44082__"